import { appendable } from "@tblabs/truffle/Core/appendable";


export class CalendarEntry
{
    constructor(
        public Date: Date,
        public Content: () => appendable[])
    { }
}
